import type { LegalDocument } from "./content-types.ts"
import { PRIVACY_POLICY } from "./privacy-policy.ts"
import { SERVICE_TERMS } from "./service-terms.ts"

export const LEGAL_DOCUMENTS = {
  "terms-service": SERVICE_TERMS,
  "terms-privacy": PRIVACY_POLICY,
  "terms-point": { announcedAt: null, effectiveAt: null, preamble: [], publishable: false, sections: [], slug: "terms-point", title: "전환·통합잔액 운영정책", version: "0.1" },
} as const satisfies Readonly<Record<string, LegalDocument>>
